import { EventGoalKpi, KpiMetric } from "@/types/EventGoal";

/**
 * What makes two KPI rows "the same KPI" when there is no server id to go by
 * (wizard drafts, AI tool rows). For every plain metric that is the metric
 * itself — one row each. A COHORT_SHARE is only the same KPI when it measures
 * the same cohort: matching it by metric alone made a second cohort KPI
 * overwrite the first.
 */
type IdentityParts = {
  metric?: KpiMetric | string;
  dimension?: string | null;
  bucketValue?: string | null;
  baseDimension?: string | null;
  baseValue?: string | null;
};

export function kpiIdentity(kpi: IdentityParts): string {
  if (kpi.metric !== "COHORT_SHARE") return String(kpi.metric ?? "");
  // JSON, not a joined string: dimension and value are free text and may
  // contain any separator.
  const parts = ["COHORT_SHARE", (kpi.dimension ?? "").trim(), (kpi.bucketValue ?? "").trim()];
  // The group only when there is one: a plain share keeps the identity it
  // always had (stored drafts, dashboard templates).
  const baseDimension = (kpi.baseDimension ?? "").trim();
  const baseValue = (kpi.baseValue ?? "").trim();
  if (baseDimension && baseValue) parts.push(baseDimension, baseValue);
  return JSON.stringify(parts);
}

export function sameKpiIdentity(a: IdentityParts, b: IdentityParts): boolean {
  return kpiIdentity(a) === kpiIdentity(b);
}

/** Stable React key: the server id when there is one, else the identity. */
export function kpiKey(kpi: EventGoalKpi): string {
  return kpi.id ?? kpiIdentity(kpi);
}
